import React, { useState, useRef, useEffect } from 'react'
import cameraIcon from './img/ic-camera.svg'
import addIcon from './img/ic-add.svg'
import shotIcon from './img/ic-shot.svg'
import cancelIcon from './img/ic-camera-cancel.svg'
import classes from './index.module.scss'
import TakePhoneDrawer from 'components/TakePhoneDrawer/index'
import { isMobile, showNotification } from 'utils/basic'
import { useI18n } from 'contexts/AuthContext'

const UploadImage = (props) => {
  const { file, setFile, description } = props
  const [drawerVisible, setDrawerVisible] = useState(false)
  const fileInputRef = useRef(null)
  const cameraInputRef = useRef(null)
  const { i18n } = useI18n()

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      if (setFile) {
        setFile(selectedFile)
      }
    }
  }

  const checkCameraPermission = async () => {
    try {
      const result = await navigator.permissions.query({ name: 'camera' })
      return result.state === 'granted'
    } catch (error) {
      showNotification({
        type: 'error',
        title: i18n('Camera permission not granted'),
      })
      return false
    }
  }

  const handleTakePhoto = () => {
    setDrawerVisible(false)

    const isOnMobile = isMobile()

    if (isOnMobile) {
      if (cameraInputRef.current) {
        cameraInputRef.current.click()
      }
    } else {
      handleDesktopCamera()
    }
  }

  const handleDesktopCamera = async () => {
    try {
      if (!checkCameraPermission()) {
        return
      }

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const video = document.createElement('video')
        video.style.position = 'fixed'
        video.style.top = '0'
        video.style.left = '0'
        video.style.width = '100%'
        video.style.height = '100%'
        video.style.objectFit = 'cover'
        video.style.zIndex = '9999'
        video.style.backgroundColor = 'black'

        const captureButton = document.createElement('img')
        captureButton.src = shotIcon
        captureButton.style.position = 'fixed'
        captureButton.style.bottom = '50px'
        captureButton.style.left = '50%'
        captureButton.style.transform = 'translateX(-50%)'
        captureButton.style.width = '60px'
        captureButton.style.height = '60px'
        captureButton.style.zIndex = '10000'
        captureButton.style.cursor = 'pointer'

        const cancelButton = document.createElement('img')
        cancelButton.src = cancelIcon
        cancelButton.style.position = 'fixed'
        cancelButton.style.top = '20px'
        cancelButton.style.right = '20px'
        cancelButton.style.width = '50px'
        cancelButton.style.height = '50px'
        cancelButton.style.zIndex = '10000'
        cancelButton.style.cursor = 'pointer'

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        const cleanup = () => {
          document.body.removeChild(video)
          document.body.removeChild(captureButton)
          document.body.removeChild(cancelButton)
          if (stream) {
            stream.getTracks().forEach((track) => track.stop())
          }
        }

        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'user',
          },
        })

        video.srcObject = stream
        video.play()
        document.body.appendChild(video)
        document.body.appendChild(captureButton)
        document.body.appendChild(cancelButton)

        captureButton.onclick = () => {
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight
          context.drawImage(video, 0, 0)

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const capturedFile = new File(
                  [blob],
                  `camera-capture-${Date.now()}.jpg`,
                  {
                    type: 'image/jpeg',
                  }
                )

                if (setFile) {
                  setFile(capturedFile)
                }
              }
            },
            'image/jpeg',
            0.8
          )

          cleanup()
        }

        cancelButton.onclick = () => {
          cleanup()
        }
      } else {
        if (cameraInputRef.current) {
          cameraInputRef.current.click()
        }
      }
    } catch (error) {
      console.error('camera error:', error)
      if (cameraInputRef.current) {
        cameraInputRef.current.click()
      }
    }
  }

  const handleSelectFromLibrary = () => {
    setDrawerVisible(false)
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const imageUrl = file ? URL.createObjectURL(file) : null

  useEffect(() => {
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl)
      }
    }
  }, [imageUrl])

  return (
    <div className={classes.styles}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt='Uploaded'
          style={{
            width: '100%',
            objectFit: 'cover',
            aspectRatio: '1',
            objectPosition: 'center',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
          onClick={() => setDrawerVisible(true)}
        />
      ) : (
        <div className='empty-image-sec' onClick={() => setDrawerVisible(true)}>
          <img src={cameraIcon} alt='Camera' className='camera-icon' />
          <img src={addIcon} alt='Add' className='add-icon' />
        </div>
      )}
      <div className='card-description'>{description}</div>
      <TakePhoneDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        onTakePhoto={handleTakePhoto}
        onSelectFromLibrary={handleSelectFromLibrary}
      />

      <input
        ref={fileInputRef}
        type='file'
        accept='image/*'
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />

      <input
        ref={cameraInputRef}
        type='file'
        accept='image/*'
        capture='environment'
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
    </div>
  )
}

export default UploadImage
